const landing360View = () => {
    function setRotator(){
        let spriteWidth = getComputedStyle(document.documentElement).getPropertyValue('--spriteWidth');
        let spriteWidthParse = parseInt(spriteWidth)
        let spriteSlider = document.createElement('div');
        let targetWidth = spriteWidthParse
        document.body.appendChild(spriteSlider);
        spriteSlider.slider = document.getElementById('intro-3d-view');
        spriteSlider.sprite = document.getElementById('intro-3d-target');
        spriteSlider.spritesize = targetWidth;
        spriteSlider.spritecount = 52;
        spriteSlider.pixelsperincrement = 15;
        spriteSlider.multiplier = spriteSlider.lastmultiplier = 0;
        Draggable.create(spriteSlider, {
            type: 'x',
            trigger: spriteSlider.slider,
            bounds: { minX:0, maxX:0, minY:0, maxY:0 },
            edgeResistance: 0,
            cursor: 'grab',
            onDrag: function() {
                if (this.isDragging) {
                    let t = this.target;
                    t.multiplier = Math.floor(this.x / t.pixelsperincrement) + t.lastmultiplier;
                    TweenLite.set(t.sprite, { backgroundPosition: -(t.multiplier * t.spritesize) + "px 0"});
                    TweenLite.set(spriteSlider.slider,{cursor:"grabbing"});
                }
            },

            onDragEnd: function()	{
                let t = this.target;
                t.lastmultiplier = t.multiplier % t.spritecount;
            }
        });
    }

    setRotator();

    $(window).resize(function() {
        let spriteTarget = document.getElementById('intro-3d-target')
        TweenLite.set(spriteTarget, { backgroundPosition: 0 + "px 0"});
        setRotator();
    });
}

export default landing360View;
